//#region src/variants/variants_dropdown.js
var variants_dropdown_default = {
	default: {
		props: {
			navigationType: { initialValue: "arrow-keys" },
			open: { initialValue: false },
			modal: { initialValue: false }
		},
		slots: {
			anchor: { initialValue: "<dt-button>Click to open</dt-button>" },
			list: { initialValue: "<dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\">Menu Item 1</dt-list-item><dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\">Menu Item 2</dt-list-item><dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\">Menu Item 3</dt-list-item>" }
		}
	},
	"with groups": {
		props: {
			navigationType: { initialValue: "arrow-keys" },
			open: { initialValue: false },
			modal: { initialValue: false }
		},
		slots: {
			anchor: { initialValue: "<dt-button>Click to open</dt-button>" },
			list: { initialValue: "<dt-list-item-group heading=\"Menu Heading A\"><dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\">Menu Item 1</dt-list-item><dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\">Menu Item 2</dt-list-item></dt-list-item-group><dt-dropdown-separator /><dt-list-item-group heading=\"Menu Heading B\"><dt-list-item role=\"menuitem\" navigation-type=\"arrow-keys\">Menu Item 3</dt-list-item></dt-list-item-group>" }
		}
	}
};
//#endregion
export { variants_dropdown_default as default };

//# sourceMappingURL=variants_dropdown.js.map